import React from 'react'

const { AdminBlock } = global.rootRequire('components/shares/rxTemplates')
const RxCrud = global.rootRequire('components/shares/rxCrud').default

export const renderTableHead = (context, vm) =>
  <tr>
    <th className={context.helpSortClass('name', ['rx-th-width-220'])} onClick={(e) => context.onClickSort(e, 'name')}>Name</th>
    <th className={context.helpSortClass('xsrf_token', ['rx-th-width-220'])} onClick={(e) => context.onClickSort(e, 'xsrf_token')}>GA_XSRF_TOKEN</th>
    <th className={context.helpSortClass('secure_psid', ['rx-th-width-220'])} onClick={(e) => context.onClickSort(e, 'secure_psid')}>__Secure-1PSID</th>
    <th className={context.helpSortClass('created_at', ['rxwidth--120'])} onClick={(e) => context.onClickSort(e, 'created_at')}>Created at</th>
    <th className='rxwidth--100'>Action</th>
  </tr>

export const renderTableBody = (context, vm) => global.rxu.array(context.state.data).map(perdata =>
  <tr key={perdata._id}>
    <td className='betable__gamelink'>{perdata.name}</td>
    <td style={{ wordBreak: 'break-all' }}>{perdata.xsrf_token}</td>
    <td style={{ wordBreak: 'break-all' }}>{perdata.secure_psid}</td>
    <td><small>{global.rxu.date(perdata.created_at)}</small></td>
    {context.renderTableBodyBtns(context, perdata)}
  </tr>)

export const renderComponent = (vm) =>
  <AdminBlock name='GA Auth' desc='Cấu hình GA_XSRF_TOKEN và __Secure-1PSID. Lần chạy authGA gần nhất sẽ lấy bản ghi mới nhất.'>
    <div className='rxcol-100'>
      <RxCrud
        onClickDataNew={vm.onClickDataNew}
        renderTableHead={vm.renderTableHead}
        renderTableBody={vm.renderTableBody}
        name='gaauth'
        api='api_gaauth'
        form={[
          { type: 'devide' },
          { name: 'Name', func: (inthis) => (<input tabIndex='1' type='text' value={inthis.state.editingData.name} onChange={(e) => inthis.onBlurData(e, 'name')} className='fullwidth-input' />) },
          { type: 'devide' },
          { name: 'GA_XSRF_TOKEN', func: (inthis) => (<input tabIndex='1' type='text' value={inthis.state.editingData.xsrf_token} onChange={(e) => inthis.onBlurData(e, 'xsrf_token')} className='fullwidth-input' />) },
          { name: '__Secure-1PSID', func: (inthis) => (<input tabIndex='1' type='text' value={inthis.state.editingData.secure_psid} onChange={(e) => inthis.onBlurData(e, 'secure_psid')} className='fullwidth-input' />) }
        ]}
      />
    </div>
  </AdminBlock>
